"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var NumberValidator_1 = require("./NumberValidator");
function createNumberRegexp(minDecimals, maxDecimals) {
    if (minDecimals === void 0) { minDecimals = 0; }
    if (maxDecimals === void 0) { maxDecimals = 2; }
    return new RegExp("^([-]?[0-9]+)([,.][0-9]{" + minDecimals + "," + maxDecimals + "})(?<![,.])$");
}
exports.decimalValidator = {
    name: 'decimal',
    // eslint-disable-next-line complexity
    validation: function (value, element, config) {
        var valueWithoutWhitespace = utils_1.isDefined(value) ? String(value).replace(utils_1.WHITESPACE_PATTERN, '') : value;
        var minDecimalsAsNumber = utils_1.isDefined(config.minDecimals) ? Number(config.minDecimals) : undefined;
        var maxDecimalsAsNumber = utils_1.isDefined(config.maxDecimals) ? Number(config.maxDecimals) : undefined;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (config.minDecimals && isNaN(minDecimalsAsNumber))
            throw new Error('config.minDecimals must be a number');
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (config.maxDecimals && isNaN(maxDecimalsAsNumber))
            throw new Error('config.maxDecimals must be a number');
        return utils_1.isEmpty(valueWithoutWhitespace) || createNumberRegexp(minDecimalsAsNumber, maxDecimalsAsNumber).test(valueWithoutWhitespace);
    },
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    formatter: NumberValidator_1.numberValidator.formatter,
};
//# sourceMappingURL=DecimalValidator.js.map